import {
  GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  GET_VERIFICATIONS_REQUESTS_LIST_RESPONSE,
  GET_VERIFICATION_REQUEST_MAIN_INFO
} from "./types";

const INITIAL_STATE = {
  verificationRequests: {
    list: [],
    meta: {}
  },
  verificationRequestMainInfo: {},
  offPlatformVerificationRequestDetails: {},
  onlinePaymentVerificationRequestDetails: {},
  bankTransferVerificationRequestDetails: {}
};

const businessVerification = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_VERIFICATIONS_REQUESTS_LIST_RESPONSE:
      return {
        ...state,
        verificationRequests: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case GET_VERIFICATION_REQUEST_MAIN_INFO:
      return {
        ...state,
        verificationRequestMainInfo: action.payload
      };
    case GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_RESPONSE:
      return {
        ...state,
        offPlatformVerificationRequestDetails: action.payload
      };
    case GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_RESPONSE:
      return {
        ...state,
        onlinePaymentVerificationRequestDetails: action.payload
      };
    case GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_RESPONSE:
      return {
        ...state,
        bankTransferVerificationRequestDetails: action.payload
      };
    default:
      return state;
  }
};

export default businessVerification;
